<!--
 * @Description: 
 * @Date: 2019-11-04 11:48:02
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 11:58:47
 -->
<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <!-- <v-icon>mdi-close</v-icon> -->
          </v-btn>
          <v-toolbar-title>
              <v-img
              width="40"
              height="40"
              style="margin-top: 5px;"
              class="thumb_url__"
              v-if="data.thumb_url !== ''"
              :src="data.thumb_url"
            ></v-img>
            <v-img
              width="40"
              height="40"
              style="margin-top: 5px;"
              class="thumb_url__"
              v-else
              src="../../assets/global_default_head@3x.png"
            ></v-img>
            <span style="position: relative; top: -13px;left: 10px;"> {{ data.tag_name==''?data.user_name:data.tag_name }} 患者 </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn dark text @click="dialog = false">Save</v-btn> -->
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <!-- <v-subheader>User Controls</v-subheader> -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>账号：{{ data.phone }}</v-list-item-title>
              <v-list-item-title>
                  昵称：{{ data.user_name }}
                  <span v-if="data.tag_name !== ''" > ( {{data.tag_name}} ) </span>
                  <v-btn color="primary" text icon value="justify_" @click="remarks">
                      <v-icon>rate_review</v-icon>
                  </v-btn>
              </v-list-item-title>
              <v-col cols="12" sm="6" class="py-2">
                <!-- <p>Text Options</p> -->
                <v-btn-toggle v-model="text" tile color="deep-purple accent-3" group>
                  <v-btn value="left">IIEF-5</v-btn>
                  <v-btn value="center">EHS</v-btn>
                  <v-btn value="right">档案</v-btn>
                  <v-btn value="justify">检测</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader class="list__">
          <!-- <v-subheader>IIEF-5 评分</v-subheader> -->
          <v-list-item>
            <!-- IIEF5 -->
            <Iief5 :iief5="iief5" :iief5Number="iief5Number" v-if="text == 'left'" ></iief5>
            <!-- EHS -->
            <EHS :ehs="EHS" v-else-if="text == 'center'"></EHS>
            <!-- 档案 -->
            <File :file="file" v-else-if="text == 'right'"></File>
            <!-- 检测 -->
            <Detect :detect="detect" v-else-if="text == 'justify'" ></Detect>

          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
    <RemarksName ref="RemarksName"></RemarksName>
  </v-row>
</template>

<script>
import RemarksName from './remarksName.vue';
import Iief5 from './iief5.vue';
import EHS from './EHS.vue';
import File from './file.vue';
import Detect from './detect.vue';
export default {
  components:{
      RemarksName,
      Iief5,
      EHS,
      File,
      Detect
  },
  data() {
    return {
      dialog: false,
      text: 'left',
      data: {},
      iief5: {
          create_time: 1571734490,
          scores: [0, 0, 0, 0, 0],
          user_id: 0
      },
      iief5Number: 0,
      EHS:{},
      file:{},
      detect:{}
    };
  },
  methods: {
    info(state, data) {
      this.dialog = state;
      this.data = data;
      this.iief5Fun();
      this.ehsFun();
      this.fileFun();
      this.detectFun();
    },
    remarks(){
        this.$refs.RemarksName.info( true, this.data );
    },
    remarks_name( name ){
        this.data.tag_name = name;
    },
    /* iief-5 */
    iief5Fun(){
        // inspection_iief5
        this.$axios({
            method: "get",
            url: `${this.$apis.URL.inspection_iief5}?user_id=${this.data.id}`,
            data: {}
        })
        .then(req => {
          if (req.data.result == 0) {
            window.console.log( req.data );
            if(req.data.datas.length > 0){
                this.iief5 = req.data.datas[0];
                let num = 0;
                this.iief5.scores.forEach(item => {
                    num += item;
                });
                this.iief5Number = num;
            }
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    },
    /* EHS */ 
    ehsFun(){
        // inspection_ehs
        this.$axios({
            method: "get",
            url: `${this.$apis.URL.inspection_ehs}?user_id=${this.data.id}`,
            data: {}
        })
        .then(req => {
          if (req.data.result == 0) {
            window.console.log( req.data );
            this.EHS = req.data.datas[0];
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    },
    /* 档案 */ 
    fileFun(){
        // inspection_cases_file
        this.$axios({
            method: "get",
            url: `${this.$apis.URL.inspection_cases_file}?user_id=${this.data.id}`,
            data: {}
        })
        .then(req => {
          if (req.data.result == 0) {
            window.console.log( req.data );
            this.file = req.data.datas;
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    },
    /* 检测 */
    detectFun(){
        // inspection_ed_monitor_type
        this.$axios({
            method: "get",
            url: `${this.$apis.URL.inspection_ed_record}?user_id=${this.data.id}`,
            data: {}
        })
        .then(req => {
          if (req.data.result == 0) {
            this.detect = req.data.datas;
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.thumb_url__{
    display: inline-block;
}
.v-toolbar__title{
    width: 300px;
}
.v-list-item__title{
    padding-left: 30px;
    margin-top: 10px;
}
.list__{
    height: calc( 100vh - 233px );
    overflow-y: auto;
}
</style>